<template>
    <div :class="[$style['mds-empty-state'], classObject, sizeClass]" :data-mds-version="version">
        <div v-if="$slots['mds-empty-state-icon']" :class="$style['mds-empty-state__icon']">
            <slot name="mds-empty-state-icon" />
        </div>
        <div :class="$style['mds-empty-state__title']">
            {{ title }}
        </div>
        <div :class="$style['mds-empty-state__message']" v-html="message" />
        <ul v-if="list" :class="$style['mds-empty-state__list']">
            <li v-for="(item, index) in list" :key="`mds-empty-state__list-${index}`">
                {{ item }}
            </li>
        </ul>
        <div v-if="$slots['mds-empty-state-actions']" :class="$style['mds-empty-state__actions']">
            <slot name="mds-empty-state-actions" />
        </div>
    </div>
</template>

<script>
    import packageInfo from '../package.json';
    const { name, version } = packageInfo;

    export default {
        name: 'MdsEmptyState',
        data() {
            return {
                version: `${name}-${version}`,
            };
        },
        props: {
            list: {
                type: Array,
                docs: {
                    validation: '—',
                    description: 'Displays each array item in an unordered list below the message.',
                },
            },
            message: {
                type: String,
                required: true,
                docs: {
                    validation: '—',
                    description: 'Sets the message for the empty state.',
                    support: ['v-html'],
                },
            },
            onDark: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, changes component to on-dark styling.',
                },
            },
            size: {
                type: String,
                default: 'medium',
                validator(value) {
                    return ['small', 'medium', 'large'].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `small`, `medium`, `large`.',
                    description: 'Sets the size of the empty state.',
                },
            },
            title: {
                type: String,
                required: true,
                docs: {
                    validation: '—',
                    description: 'Sets the title for the empty state.',
                },
            },
        },
        computed: {
            sizeClass() {
                return this.$style[`mds-empty-state--${this.size}`];
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-component--on-dark']] = this.onDark;

                return obj;
            },
        },
    };
</script>

<style lang="scss" module>
    @import './empty-state.scss';
</style>
